import { render, staticRenderFns } from "./SubscriptionManager.vue?vue&type=template&id=4b527d6a&scoped=true"
import script from "./SubscriptionManager.vue?vue&type=script&lang=js"
export * from "./SubscriptionManager.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionManager.vue?vue&type=style&index=0&id=4b527d6a&prod&scoped=true&lang=css"
import style1 from "./SubscriptionManager.vue?vue&type=style&index=1&id=4b527d6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b527d6a",
  null
  
)

export default component.exports